import React from 'react';
import { LegalDocumentLayout } from './common/LegalDocumentLayout';
import { LegalSection, LegalList, LegalListItem, LegalSubsection } from './common/LegalSection';

export const TermsBusiness: React.FC = () => {
  return (
    <LegalDocumentLayout
      title={'Regulamin Obiektu\nPlatformy Spotto.pl'}
      lastUpdated="02.04.2026"
    >
      <LegalSection number={1} title="Postanowienia ogólne">
        <LegalSubsection number="1.1.">
          Regulamin określa zasady współpracy Obiektu z platformą rezerwacyjną SPOTTO.pl
          („Platforma", „Platforma Spotto"), prowadzoną przez SOLIDLABS PSA („Administrator")
          o numerze NIP: 6751768986, z siedzibą w Krakowie przy ul. Mogilskiej 43,
          kod pocztowy 31-545.
        </LegalSubsection>
        <LegalSubsection number="1.2.">
          Obiektem (lub Biznesem) jest podmiot gospodarczy prowadzący działalność sportową
          lub rekreacyjną, udostępniający swoje usługi i powierzchnie Użytkownikom Platformy.
        </LegalSubsection>
        <LegalSubsection number="1.3.">
          Korzystanie z Platformy oznacza akceptację niniejszego Regulaminu oraz Regulaminu
          Głównego Platformy Spotto.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={2} title="Obowiązki formalne i uprawnienia Obiektu">
        <LegalSubsection number="2.1.">
          Obiekt oświadcza, że posiada wszelkie wymagane przepisami prawa:
        </LegalSubsection>
        <LegalList>
          <LegalListItem>zezwolenia, koncesje lub decyzje administracyjne,</LegalListItem>
          <LegalListItem>ubezpieczenie OC,</LegalListItem>
          <LegalListItem>spełnia wymogi sanitarne, techniczne i BHP.</LegalListItem>
        </LegalList>
        <LegalSubsection number="2.2.">
          Na żądanie Administratora Obiekt zobowiązany jest przedstawić dokumenty potwierdzające
          posiadanie wymaganych uprawnień.
        </LegalSubsection>
        <LegalSubsection number="2.3.">
          Brak aktualnych uprawnień stanowi podstawę do natychmiastowego zawieszenia konta
          Obiektu.
        </LegalSubsection>
        <LegalSubsection number="2.4.">
          Obiekt zobowiązany jest do wskazania i utrzymywania na swoim profilu w Platformie
          Spotto aktualnych danych kontaktowych, w szczególności numeru telefonu oraz adresu
          poczty elektronicznej, umożliwiających Użytkownikom kontakt z Obiektem w celu
          uzyskania dodatkowych informacji, zgłaszania pytań oraz składania reklamacji.
        </LegalSubsection>
        <LegalSubsection number="2.5.">
          Obiekt zobowiązany jest przestrzegać zasad i regulaminów obowiązujących
          w wykorzystywanych systemach płatniczych, a w szczególności stosować się do
          ograniczeń sprzedaży produktów i usług zakazanych, np. broni, amunicji, środków
          podwójnego zastosowania, etc.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={3} title="Rezerwacje i płatności">
        <LegalSubsection number="3.1.">
          Rezerwacje dokonywane przez Użytkowników są płatne i realizowane za pośrednictwem
          systemu transakcyjnego Platformy.
        </LegalSubsection>
        <LegalSubsection number="3.2.">
          Obiekt zobowiązuje się do rzetelnego utrzymywania dostępności terminów i cen.
        </LegalSubsection>
        <LegalSubsection number="3.3.">
          Każda rezerwacja stanowi wiążącą umowę pomiędzy Użytkownikiem a Obiektem
          — Administrator nie jest jej stroną.
        </LegalSubsection>
        <LegalSubsection number="3.4.">
          Obiekt może stosować własną politykę w zakresie płatności, rezerwacji oraz zwrotów,
          pod warunkiem że nie pozostaje ona w sprzeczności z ogólnymi zasadami obowiązującymi
          na platformie (w szczególności dotyczącymi możliwości dokonania zwrotu do 48 godzin
          przed rozpoczęciem wydarzenia). Obiekt jest zobowiązany do wyraźnego określenia
          takich szczególnych warunków w swoim regulaminie, a ponadto rekomenduje się
          zamieszczenie stosownej informacji w polu „Informacje dodatkowe", widocznym dla
          klienta w widoku obiektu na platformie Spotto.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={4} title="Anulowanie rezerwacji i zwroty">
        <LegalSubsection number="4.1.">
          Obiekt akceptuje możliwość anulowania rezerwacji przez Użytkownika nie później
          niż na 48 godzin przed planowanym rozpoczęciem wydarzenia.
        </LegalSubsection>
        <LegalSubsection number="4.2.">
          W przypadku skutecznej anulacji Obiekt zobowiązany jest do zwrotu środków
          pomniejszonych o 10% wartości rezerwacji, stanowiących koszty operacyjne Platformy
          w terminie nie przekraczającym 14 dni roboczych.
        </LegalSubsection>
        <LegalSubsection number="4.3.">
          Poprawnie zgłoszona anulacja jest potwierdzana automatycznie wiadomością e-mail.
        </LegalSubsection>
        <LegalSubsection number="4.4.">
          Forma i termin zwrotu pozostałej kwoty ustalane są pomiędzy Obiektem a Użytkownikiem
          — Administrator nie pośredniczy w rozliczeniach.
        </LegalSubsection>
        <LegalSubsection number="4.5.">
          W przypadku odwołania wydarzenia z winy Obiektu, Obiekt zobowiązany jest do pełnego
          zwrotu środków Użytkownikowi.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={5} title="Odpowiedzialność">
        <LegalSubsection number="5.1.">
          Obiekt ponosi pełną odpowiedzialność za:
        </LegalSubsection>
        <LegalList>
          <LegalListItem>bezpieczeństwo Użytkowników na terenie obiektu,</LegalListItem>
          <LegalListItem>stan techniczny infrastruktury,</LegalListItem>
          <LegalListItem>realizację usług zgodnie z opisem.</LegalListItem>
        </LegalList>
        <LegalSubsection number="5.2.">
          Administrator nie ponosi odpowiedzialności za niewykonanie lub nienależyte wykonanie
          usług przez Obiekt.
        </LegalSubsection>
        <LegalSubsection number="5.3.">
          Wszelkie roszczenia Użytkowników dotyczące realizacji usług kierowane są bezpośrednio
          do Obiektu.
        </LegalSubsection>
        <LegalSubsection number="5.4.">
          Administrator dostarcza system transakcyjny i ponosi odpowiedzialność za
          funkcjonowanie systemu.
        </LegalSubsection>
        <LegalSubsection number="5.5.">
          Administrator nie jest stroną umowy ani stosunków prawnych pomiędzy Użytkownikiem
          a Obiektem lub Trenerem, w szczególności zawartej umowy sprzedaży, dlatego nie
          ponosi odpowiedzialności z nimi związanej.
        </LegalSubsection>
        <LegalSubsection number="5.6.">
          Administrator nie ponosi odpowiedzialności za niewykonanie lub nienależyte wykonanie
          zobowiązań ze strony Użytkownika na rzecz Obiektu (brak wymaganej dopłaty za usługi
          płatne etc.).
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={6} title="Dane osobowe">
        <LegalSubsection number="6.1.">
          Administratorem danych osobowych Użytkowników jest SOLID LABS PSA o numerze NIP:
          6751768986, z siedzibą w Krakowie przy ul. Mogilskiej 43, kod pocztowy 31-545.
        </LegalSubsection>
        <LegalSubsection number="6.2.">
          Dane osobowe przetwarzane są zgodnie z przepisami RODO oraz Polityką Prywatności
          Platformy. Kontakt w sprawach ochrony danych:{' '}
          <a
            href="mailto:rodo@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            rodo@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="6.3.">
          Użytkownik ma prawo dostępu do danych, ich poprawiania, usunięcia oraz ograniczenia
          przetwarzania.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={7} title="Reklamacje i zgłoszenia nieprawidłowości">
        <LegalSubsection number="7.1.">
          Obiekt zobowiązuje się do rzetelnego i terminowego rozpatrywania reklamacji
          Użytkowników, rekomenduje się podjęcie tematu w terminie nie przekraczającym 14 dni
          od daty wpływu zgłoszenia.
        </LegalSubsection>
        <LegalSubsection number="7.2.">
          Użytkownik ma prawo zgłosić Administratorowi przypadki nieuczciwych,
          nieprofesjonalnych lub niezgodnych z Regulaminem działań Obiektu na adres:{' '}
          <a
            href="mailto:reklamacje@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            reklamacje@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="7.3.">
          Administrator nie jest stroną rezerwacji i nie ponosi odpowiedzialności za działania
          Obiektu.
        </LegalSubsection>
        <LegalSubsection number="7.4.">
          W przypadkach rażących naruszeń Administrator może zawiesić konto Obiektu lub
          rozwiązać umowę ze skutkiem natychmiastowym.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={8} title="Postanowienia końcowe">
        <LegalSubsection number="8.1.">
          Administrator ma prawo monitorować jakość usług w celu ochrony reputacji Platformy.
        </LegalSubsection>
        <LegalSubsection number="8.2.">
          Regulamin podlega prawu polskiemu.
        </LegalSubsection>
        <LegalSubsection number="8.3.">
          Naruszenie Regulaminu stanowi podstawę do zakończenia współpracy.
        </LegalSubsection>
      </LegalSection>
    </LegalDocumentLayout>
  );
};
